import { ChartComponentType } from '..'
import Axis, { AxisProps } from './AxisComponent.vue'
import Line, { LineProps } from './LineComponent.vue'
import Text, { TextProps } from './TextComponent.vue'
import DataHighlightCircle, { DataHighlightCircleProps } from './DataHighlightCircleComponent.vue'
import HighlightAreaComponent, { HighlightAreaProps } from './HighlightAreaComponent.vue'
import HighlightLine, { HighlightLineProps } from './HighlightLineComponent.vue'
import Tooltip, { TooltipProps } from './TooltipComponent.vue'

export type Font = {
  size: number
  family: string
  weight: number
  lineHeight: number
}

export const componentMap: Record<ChartComponentType, any> = {
  axis: Axis,
  line: Line,
  text: Text,
  'highlight-circle': DataHighlightCircle,
  'highlight-area': HighlightAreaComponent,
  'highlight-line': HighlightLine,
  tooltip: Tooltip
}

export type {
  TextProps,
  AxisProps,
  LineProps,
  DataHighlightCircleProps,
  HighlightAreaProps,
  HighlightLineProps,
  TooltipProps
}

export { Axis, Line, Text, DataHighlightCircle, HighlightLine, Tooltip }
